import { useEffect } from 'react';

import { useAppSelector } from 'app/hooks';
import { selectOpen } from 'common/components/EditDrawer/editDrawerSlice';
import { Operations } from 'common/types/TypeDefs';

import { RequiredCreateFieldsWIthAutoRenewalDiasbled, RequiredCreateFieldsWIthAutoRenewalEnabled } from '../ILicenseCreateDrawerContent';
import { _isCreateFormEnabled, _validateRequiredFieldsOnCreateEdit } from '../LicenseCreateEditHelpers';

export function useValidateRequiredLicenseFieldsOnCreate(
    requiredFieldsWithAutoRenewalEnabled: RequiredCreateFieldsWIthAutoRenewalEnabled,
    requiredFieldsWithAutoRenewalDisabled: RequiredCreateFieldsWIthAutoRenewalDiasbled,
    isDateValidationError: boolean,
    duplicatedCibsNotConfirmed: boolean,
    currentOperation?: Operations,
    isLicenseAutoRenewalEnabled?: boolean
): void {
    const isOpenDrawer = useAppSelector(selectOpen);

    useEffect(() => {
        if(currentOperation && _isCreateFormEnabled(currentOperation, isOpenDrawer)) {
            if(isLicenseAutoRenewalEnabled) {
                const { startDate, companyKey, billingRecord, billingSystemId } = requiredFieldsWithAutoRenewalEnabled;

                _validateRequiredFieldsOnCreateEdit<RequiredCreateFieldsWIthAutoRenewalEnabled>(
                    {
                        startDate: startDate,
                        billingSystemId: billingSystemId,
                        billingRecord: billingRecord,
                        companyKey: companyKey
                    },
                    isDateValidationError,
                    duplicatedCibsNotConfirmed
                );
            } else {
                const { startDate, endDate, companyKey, billingRecord, billingSystemId } = requiredFieldsWithAutoRenewalDisabled;

                _validateRequiredFieldsOnCreateEdit<RequiredCreateFieldsWIthAutoRenewalDiasbled>(
                    {
                        startDate, endDate, billingRecord, billingSystemId, companyKey
                    },
                    isDateValidationError,
                    duplicatedCibsNotConfirmed
                );
            }

        }
    }, [currentOperation,
        isOpenDrawer,
        requiredFieldsWithAutoRenewalEnabled.companyKey,
        requiredFieldsWithAutoRenewalEnabled.startDate,
        requiredFieldsWithAutoRenewalEnabled.billingSystemId,
        requiredFieldsWithAutoRenewalEnabled.billingRecord,
        requiredFieldsWithAutoRenewalDisabled.companyKey,
        requiredFieldsWithAutoRenewalDisabled.startDate,
        requiredFieldsWithAutoRenewalDisabled.billingSystemId,
        requiredFieldsWithAutoRenewalDisabled.billingRecord,
        requiredFieldsWithAutoRenewalDisabled.endDate,
        isLicenseAutoRenewalEnabled,
        isDateValidationError,
        duplicatedCibsNotConfirmed]);
}
